import React from 'react';
import './MessageSection.css';
import MessageIcon from './MessageIcon';

function MessageSection({ icon, header, paragraphs, altBackground = false, colors, showButton, buttonName, buttonUrl, showButtons, buttons }) {
  // colors: { svg, header, paragraph }
  const iconStyle = colors?.svg ? { color: colors.svg } : undefined;
  const headerStyle = colors?.header ? { color: colors.header } : undefined;
  const paragraphStyle = colors?.paragraph ? { color: colors.paragraph } : undefined;
  return (
    <div className={`message-section ${altBackground ? 'alt-background' : ''}`}>
      <div className="message-content">
        {icon && <span style={iconStyle}><MessageIcon icon={icon} /></span>}
        {header && <h2 className="message-header" style={headerStyle}>{header}</h2>}
        {paragraphs && paragraphs.map((paragraph, index) => (
          <p key={index} className="message-paragraph" style={paragraphStyle}>
            {paragraph}
          </p>
        ))}
        {(showButtons === true || showButtons === "true") && buttons && buttons.length > 0 && (
          <div className="message-buttons-container">
            {buttons.map((button, index) => (
              button.name && button.url && (
                <a 
                  key={index}
                  href={button.url} 
                  className="message-button"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {button.name}
                </a>
              )
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MessageSection; 